import {FC, useState, createContext, useContext, useMemo} from 'react'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
  groupingOnSelectAllV2,
} from '@/_metronic/helpers'
import { useCustomerResponse, useCustomerResponseData } from './CustomerResponseProvider'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const CustomerListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const [itemId, setItemId] = useState<string>(initialListView.itemId!)
  const {isLoading} = useCustomerResponse()
  const data = useCustomerResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])

  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAllV2(isAllSelected, setSelected, data as any)
        },
        clearSelected: () => {
          setSelected([])
        },
        itemId,
        setItemId
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useCustomerListView = () => useContext(ListViewContext)

export {CustomerListViewProvider, useCustomerListView}
